export default __webpack_public_path__ + "static/media/apple-appstore-badge.8c4986ee.svg";